/* eslint-disable no-eval, react/no-direct-mutation-state */
import React from 'react';
import { Popup, ToolbarItem as PopupToolbarItem } from 'devextreme-react/popup';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as projectsCrud from '../../../crud/projects.crud';
import * as contractsCrud from '../../../crud/contracts.crud';
import * as companiesCrud from '../../../crud/companies.crud';
import { withSnackbar } from 'notistack';
import * as commonCrud from '../../../crud/common.crud';
import axios from 'axios';
import { Validator, RequiredRule, } from 'devextreme-react/validator';
import { SelectBox, DropDownBox, Switch, ValidationGroup } from 'devextreme-react';
import DefaultWorkflows from '../../../Templates/DefaultWorkflows';
import DataGrid, { Column, SearchPanel, HeaderFilter, FilterPanel, FilterRow, Selection, Scrolling, ColumnChooser, ColumnFixing } from 'devextreme-react/data-grid';
import * as reportingClientCrud from "../../../crud/powerBIReportingClient.crud";
import Spinner from '../../../partials/layout/Spinner';

export const RESPONSE = {
    OK: 'OK',
    CANCEL: 'CANCEL',
    CREATE: 'CREATE'
};
const initialState = {
    copyattachment: false,
    contractsList: null,
    selectedContracts: [],
    isbusy: false,
    isnotificationcopied: false,
    newDraftObjects: null,
    instances: null,
    selectedInstance: null,
    filteredContracts: null,
    credentials: null
};
class ActionCopyToOtherInstanceModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'ActionCopyModalValidator';
        this.formRef = React.createRef();
        this.gridRef = React.createRef();
        this.dataGrid = React.createRef();
        this.contractsDropdown = React.createRef();
        this.contractGridColumns = [
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.ID" }), dataField: "contractId" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.NAME" }), dataField: "contractName" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.TYPE" }), dataField: "contractType" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.PROJECT_NAME" }), dataField: "projectName" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.CLIENT.COMPANY" }), dataField: "clientCompanyName" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.SUPPLIER.COMPANY" }), dataField: "supplierCompanyName" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.PM.COMPANY" }), dataField: "projectManagerCompanyName" },
            { caption: this.props.intl.formatMessage({ id: "CONTRACT.FIELD.SUPERVISOR.COMPANY" }), dataField: "supervisorCompanyName" }
        ];
        this.formData = {}
        this.defaultFields = null;

        this.state = {
            ...initialState
        }
    }



    componentDidUpdate(prevProps) {
        // Run activation logic only when `visible` changes from false to true
        if (!prevProps.visible && this.props.visible) {
            //this.updateContractsList();
            this.fetchContractGlobal();
        }
    }

    fetchContractGlobal = async () => {

        this.setState({ ...initialState, isbusy: true }, async () => {
            let credentials = null;
            //1- TRY GET CREDENTIALS
            try {
                ({ data: credentials } = await reportingClientCrud.getReportingClient());
            } catch (error) {
                credentials = null;
            }
            if (credentials) {
                try {

                    let response = await reportingClientCrud.getContractGlobal();
                    let contractsList = response.data?.items || [];

                    if (contractsList.length === 0) {
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.WARNING_NO_CONTRACT" }), { variant: "warning" });
                    }

                    // Extract unique instances for the instances dropdown
                    const instances = [...new Set(contractsList.map(item => item.instance))]
                        .map(inst => ({ instance: inst }));
                    this.setState({
                        contractsList,
                        instances,
                        selectedInstance: null,
                        filteredContracts: contractsList, // Initially show all
                        isbusy: false,
                        credentials
                    });
                } catch (error) {
                    this.props.enqueueSnackbar(error.toString(), { variant: 'error' });
                    this.setState({
                        contractsList: [],
                        instances: [],
                        selectedInstance: null,
                        filteredContracts: [],
                        isbusy: false,
                        credentials: null,
                    });
                }
            }
            else {
                let { data: companies } = await companiesCrud.getCutDownCompaniesList();
                let companyNamesObject = companies.reduce((obj, company) => {
                    obj[company.companyid] = company.name;
                    return obj;
                }, {});

                let localContracts = (this.props.contracts || []).map(c => ({
                    contractId: c.contractid,
                    contractName: c.name,
                    instance: window.location.hostname.split('.')[0], // Assuming the current instance is the hostname prefix
                    contractType: c.contracttype,
                    projectName: c.project,
                    clientCompanyName: companyNamesObject[c.employercompanyid] || "",
                    supplierCompanyName: companyNamesObject[c.contractorcompanyid] || "",
                    projectManagerCompanyName: companyNamesObject[c.pmcompanyid] || "",
                    supervisorCompanyName: companyNamesObject[c.supervisorcompanyid] || "",
                }));
                this.setState({
                    contractsList: localContracts,
                    instances: [],
                    selectedInstance: null,
                    filteredContracts: localContracts,
                    isbusy: false,
                    credentials: null
                });
            }

        });




    };

    onInstanceChanged = (e) => {
        const instanceName = e.value;
        const { contractsList } = this.state;

        // Filter the full list based on the chosen instance
        const filtered = instanceName
            ? contractsList.filter(c => c.instance === instanceName)
            : contractsList;

        this.setState({
            selectedInstance: instanceName,
            filteredContracts: filtered,
            selectedContracts: [] // Optional: clear selected contracts when instance changes
        });

        // Manually clear the selection in the DataGrid inside the dropdown
        if (this.dataGrid.current?.instance) {
            var gridInstance = this.dataGrid.current.instance();
            if (gridInstance) {
                gridInstance.clearSelection();
            }
        }
    };

    contractsGridOnSelectionChanged = (e, b) => {
        const { selectedContracts } = this.state;
        //The newly selected contracts
        const newlySelectedContracts = e.selectedRowKeys.filter(key => !selectedContracts || !selectedContracts.includes(key));

        //The contracts that are no longer selected
        const deselectedContracts = selectedContracts ? selectedContracts.filter(key => !e.selectedRowKeys.includes(key)) : [];
        if (newlySelectedContracts.length > 0 || deselectedContracts.length > 0) {
            //Update the selectedContracts state
            const updatedSelectedContracts = selectedContracts ? [...selectedContracts, ...newlySelectedContracts].filter(key => !deselectedContracts.includes(key)) : [...newlySelectedContracts];
            this.setState({ selectedContracts: updatedSelectedContracts });
        }
    }

    updateContractsList = async () => {
        try {
            if (this.requestSource) {
                this.requestSource.cancel('Operation canceled due to new request.');
            }
            this.requestSource = axios.CancelToken.source();

            this.setState({ contractsList: [] }, async () => {
                let { data: contractsList } = await contractsCrud.getContractOptionsForProject(this.props.projectId, this.props.workflowItem.config.currentModel, this.requestSource.token);
                if (!Array.isArray(contractsList)) {
                    contractsList = [];
                }
                if (contractsList.length === 0) {
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.WARNING_NO_CONTRACT" }), { variant: "warning" });
                }
                this.setState({ contractsList });
            })
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ contractsList: null });
        }
    }

    onClose = () => {
        if (this.props.visible) {
            if (this.formRef.current?.instance) {
                this.formRef.current.instance().clear();
            }

            this.props.onDialogResult();
            this.formData = {}
            this.setState({ copyattachment: false, isbusy: false });
        }
    }

    saveItem = async () => {
        const validationResult = this.validatorRef.current.instance().validate();
        if (!validationResult.isValid) {
            return;
        }
        if (this.state.credentials && this.state.instances?.length > 0 && !this.state.selectedInstance) {
            this.props.enqueueSnackbar(
                this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.WARNING_NO_INSTANCE_SELECTED" }),
                { variant: "warning" }
            );
            return;
        }

        if (this.state.selectedContracts?.length) {
            try {
                this.setState({ isbusy: true }, async () => {
                    try {

                        if (this.state.instances?.length < 1 && this.state.credentials) {
                            throw new Error(this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.WARNING_NO_INSTANCE_SELECTED" }));
                        } else {
                            let targetinstance = this.state.credentials ? this.state.selectedInstance : window.location.hostname.split('.')[0]; // Assuming the current instance is the hostname prefix
                            const copyToInstancePayload = {
                                targetinstance: targetinstance,
                                workflowid: this.props.workflowItem.id,
                                targetcontractids: this.state.selectedContracts,
                                copyattachment: this.state.copyattachment,
                                recordid: Number(this.props.params.notificationid),
                                contractid: this.props.contract.contractid,
                            };

                            const response = await commonCrud.copyNotificationToOtherInstanceContracts(copyToInstancePayload);
                            let responseObj = response?.data || {};
                            if (responseObj.success) {
                                //FD-12808  TODO:  returned items are in responseObj.resultset
                                //but because they are external links they might need to be handled differntly
                                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.COPY.SUCCESSFUL' }), { variant: 'success', });

                                this.setState({ isnotificationcopied: true, newDraftObjects: responseObj.resultset });
                            }
                            else {
                                this.props.enqueueSnackbar(responseObj.statuscode + ': ' + responseObj.message, { variant: 'error', });
                            }
                        }



                        this.setState({
                            copyattachment: false,
                            projects: null,
                            contractsList: null,
                            isbusy: false
                        });
                    } catch (err) {
                        this.setState({ isbusy: false });
                        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                    }
                })
            } catch (err) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }

            return;
        } else {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.WARNING_NO_CONTRACT_SELECTED" }), { variant: "warning" });
        }
    }

    onDropdownValueChanged = (e) => {
        if (e.value == null) {
            //selection cleared
            this.dataGrid.current.instance().clearSelection();
        }
    }

    onCopyAttachmentChanged = (e) => {
        this.setState({ copyattachment: e.value })
    }

    onLinkClicked = (e) => {
        if (!e.row || !e.row.data) {
            return;
        }
        if (e.row.data.toinstance) {
            let externalURL = `https://${e.row.data.toinstance}.builtintelligence.com/contract/${e.row.data.contractid}/generic-drafts?genericdraftid=${e.row.data.notificationid}`;
            window.open(externalURL, '_blank');
            return;
        }
    }

    render() {
        if (!this.props.visible) {
            return null;
        }

        if (this.state.isnotificationcopied && this.state.newDraftObjects) {
            return (
                <Popup
                    visible={this.props.visible}
                    onHiding={this.onClose}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    // showTitle={true}
                    // title={this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.COPY.COPIED.DRAFTS' })}
                    width={600}
                    height='auto'
                >
                    <DataGrid
                        ref={this.gridRef}
                        //width='100%'
                        height='100%'
                        dataSource={this.state.newDraftObjects}
                        keyExpr="contractid"
                        hoverStateEnabled={false}
                        rowAlternationEnabled={true}
                        noDataText={'No Data'}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        remoteOperations={false}
                        columns={[
                            {
                                caption: this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.COPY.COPIED.CONTRACTID' }),
                                dataField: "contractid"
                            },
                            {
                                caption: this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.COPY.COPIED.NOTIFICATIONID' }),
                                dataField: "notificationid"
                            },
                            {
                                type: "buttons",
                                buttons: [{ hint: this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.COPY.GO_TO_DRAFT' }), icon: 'link', onClick: this.onLinkClicked }]
                            }
                        ]}
                    >
                        <HeaderFilter visible={true} />
                        <FilterPanel visible={true} />
                        <ColumnFixing enabled={true} />
                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                    </DataGrid>
                    <PopupToolbarItem location="before"
                        locateInMenu="never"
                        template={`<div style=\"font-size: 20px;\">${this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.COPY.COPIED.DRAFTS' })}</div>`}
                    />
                </Popup>
            )
        }

        return (
            <Popup
                id='createActionDuplicatePopup'
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={true}
                hideOnOutsideClick={false}
                // showTitle={true}
                // title={this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.COPY.TITLE" })}
                width={600}
                disabled={this.state.isbusy}
                height='auto'>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <ValidationGroup ref={this.validatorRef} name="CopyNoticeToOtherInstanceValidator">
                        {
                            process.env.REACT_APP_ATTACHMENT_MODE === 'DEFAULT' && (
                                <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>
                                    <div style={{ flex: 1, paddingRight: '10px' }}>
                                        <span>{this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.DUPLICATE.COPY_ATTACHMENTS' })}:&nbsp;&nbsp;</span>
                                    </div>
                                    <div style={{ flex: 2 }}>
                                        <Switch
                                            dataField='copyattachment'
                                            defaultValue={this.state.copyattachment}
                                            onValueChanged={this.onCopyAttachmentChanged}
                                            switchedOffText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}
                                            switchedOnText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}
                                            disabled={this.state.isbusy}
                                        />
                                    </div>
                                </div>
                            )
                        }

                        {
                            !!this.state.credentials && (
                                <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>
                                    <div style={{ flex: 1, paddingRight: '10px' }}>
                                        <span>{this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.INSTANCE' })}:&nbsp;&nbsp;</span>
                                    </div>
                                    <div style={{ flex: 2 }}>
                                        <SelectBox
                                            value={this.state.selectedInstance}
                                            valueExpr="instance"
                                            displayExpr="instance"
                                            dataSource={this.state.instances}
                                            onValueChanged={this.onInstanceChanged}
                                            showClearButton={true}
                                            searchEnabled={true}
                                            disabled={this.state.isbusy}
                                            required={true}
                                        >
                                            <Validator>
                                                <RequiredRule message={this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.INSTANCE" }) + ' ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.VALIDATION.REQUIRED' })} />
                                            </Validator>
                                        </SelectBox>
                                    </div>
                                </div>
                            )
                        }

                        <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>
                            <div style={{ flex: 1, paddingRight: '10px' }}>
                                <span>{this.props.intl.formatMessage({ id: 'NOTIFICATION.POPUP.CONTRACTS' })}:&nbsp;&nbsp;</span>
                            </div>
                            <div style={{ flex: 2 }}>
                                <DropDownBox
                                    ref={this.contractsDropdown}
                                    id='AvailableContractsDropDown'
                                    disabled={this.state.isbusy || (this.state.credentials && !this.state.selectedInstance)}
                                    //dataSource={this.state.contractsList}
                                    dataSource={this.state.filteredContracts}
                                    valueExpr="contractId"
                                    deferRendering={true}
                                    displayExpr="contractName"
                                    placeholder={this.props.intl.formatMessage({ id: "CONTRACT.USERS.BULK.CONTRACTS_PH" })}
                                    showClearButton={true}
                                    value={this.state.selectedContracts}
                                    onValueChanged={this.onDropdownValueChanged}
                                    showDropDownButton={true}
                                    dropDownOptions={{
                                        width: '80vw',
                                        maxHeight: '50vh',
                                        showCloseButton: true,
                                        showTitle: true,
                                        title: this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.AVAILABLE_CONTRACTS" }),
                                        position: { at: "bottom", of: '#AvailableContractsDropDown' }
                                    }}
                                >
                                    <Validator>
                                        <RequiredRule message={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.CONTRACTS" }) + ' ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.VALIDATION.REQUIRED' })} />
                                    </Validator>
                                    <FilterRow visible={true} />
                                    <Column allowFiltering={false} />
                                    <DataGrid
                                        ref={this.dataGrid}
                                        keyExpr="contractId"
                                        //dataSource={this.state.contractsList}
                                        dataSource={this.state.filteredContracts}
                                        columns={this.contractGridColumns}
                                        hoverStateEnabled={true}
                                        onSelectionChanged={this.contractsGridOnSelectionChanged}
                                        style={{ height: '100%' }}
                                    >
                                        <SearchPanel visible={true} />
                                        <HeaderFilter visible={true} />
                                        <Selection mode="multiple" allowSelectAll="true" selectAllMode="allPages" showCheckBoxesMode="always" />
                                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                                        <FilterRow visible={true} />
                                        <ColumnChooser enabled={true} />
                                        <ColumnFixing enabled={true} />
                                    </DataGrid>
                                </DropDownBox>
                            </div>
                        </div>
                    </ValidationGroup>
                </div>
                <PopupToolbarItem location="before"
                    locateInMenu="never"
                    template={`<div style=\"font-size: 20px;\">${this.props.intl.formatMessage({ id: "NOTIFICATION.POPUP.COPY.TITLE" })}</div>`}
                />
                <PopupToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CANCEL' }), onClick: this.onClose }}>
                </PopupToolbarItem>
                <PopupToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CREATE_DRAFTS' }),
                        icon: this.state.isbusy ? 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--dark' : 'save',
                        onClick: this.saveItem
                    }}>
                </PopupToolbarItem>
            </Popup >
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    contracts: store.contracts.contracts
});

export default withSnackbar(injectIntl(connect(mapStateToProps)(ActionCopyToOtherInstanceModal)));